import { useQuery } from '@tanstack/react-query'
import { useRouter } from 'next/router'
import { StorageKey } from '@/client/types'
import { searchPages, getToolsData, getMedia } from '@/infra/services'
import { excludedSlugs } from '@/pages/sitemap.xml'

export const getIndexableUrls = async () => {
  const urls = [
    '/'
    // ...all your generated URLs
  ]

  return urls.map((url) => url.split('?')[0])
}

export const useSearchPages = (value?: string, section?: string) => {
  const { locale } = useRouter()

  const { data, isFetching } = useQuery({
    queryKey: [StorageKey.SEARCH, locale, value],
    queryFn: () => searchPages(locale || 'en', value, section || 'products'),
    enabled: !!value
  })

  return { data, isFetching }
}

export const useGeneralSearchPages = (value?: string, section?: string) => {
  const { locale } = useRouter()

  const { data, isFetching } = useQuery({
    queryKey: [StorageKey.SEARCH, locale, value],

    queryFn: async () => {
      // Fetch search results
      const resultData = await searchPages(locale || 'en', value, section || 'products')
      // Fetch sitemap.xml
      // Filter search results by pathname
      // const filtered = resultData.filter((item: any) => sitemapSet.has(normalize(normalize(item.url))))
      const filtered = resultData.filter((item) => {
        const currentSlug = new URL(item.url).pathname.split('/').filter(Boolean).pop()
        return !excludedSlugs.has(currentSlug || '')
      })

      // eslint-disable-next-line no-console
      console.log('resultData ', resultData, filtered, 'filtered', excludedSlugs)
      return filtered
    },

    enabled: !!value
  })

  return { data, isFetching }
}

export const useSearchBlogs = (value?: string) => {
  const { locale } = useRouter()

  const { data, isFetching } = useQuery({
    queryKey: [StorageKey.SEARCH, locale, value],
    queryFn: () => getToolsData(),
    enabled: !!value
  })

  return { data, isFetching }
}

export const useGetTools = (value?: string) => {
  const { locale } = useRouter()

  const { data, isFetching } = useQuery({
    queryKey: [StorageKey.TOOLS, locale, value],
    queryFn: () => getToolsData(),
    enabled: true
  })

  return { data, isFetching }
}

export const useGetMedia = (mediaId?: number) => {
  const { locale } = useRouter()

  const { data, isFetching } = useQuery({
    queryKey: [StorageKey.MEDIA, locale, mediaId],
    queryFn: () => getMedia(locale || 'en', mediaId),
    enabled: !!mediaId
  })

  return { data, isFetching }
}
